import React from "react";
import { Route, Routes } from "react-router-dom";
import "./assets/styles/App.css";
import { CustomerProvider } from "./lib/context/customerProvider";
import ChangePassword from "./pages/change-password/[id]";
import Customer from "./pages/customer";
import { AddCurrentCustomer } from "./pages/customer/current/add";
import { AddFutureCustomer } from "./pages/customer/future/add";
import { SelectChannelAddFutureCustomer } from "./pages/customer/future/add_channel";

import { AddCustomerCompetitorDomestic } from "./pages/customer/customercompetitor/domestic/add";
import { AddCustomerCompetitorInternational } from "./pages/customer/customercompetitor/international/add";
import { ViewCustomerCompetitorDomestic } from "./pages/customer/customercompetitor/domestic/view";
import { ViewCustomerCompetitorInternational } from "./pages/customer/customercompetitor/international/view";

import Dashboard from "./pages/dashboard";
import DashboardMarketingActionPlan from "./pages/dashboard/marketingactionplan";
import DashboardCustomerPersona from "./pages/dashboard/customerpersona";
import DashboardCustomerSegment from "./pages/dashboard/customersegment";
import DashboardFutureCustomerPersona from "./pages/dashboard/futurecustomerpersona";
import DashboardCustomerPersonaEstate from "./pages/dashboard/customerpersonaestate";
import ForgotPassword from "./pages/forgot";
import Profile from "./pages/profile/[id]";
import SignIn from "./pages/signin";
import UI from "./pages/ui";
import UserManagement from "./pages/user-management";
import AddUserRoleManagement from "./pages/user-management/role/components/add";
import EditUserRoleManagement from "./pages/user-management/role/components/edit";
import ViewUserRoleManagement from "./pages/user-management/role/components/view";

import { UserManagementProvider } from "./lib/context/userManagementProvider";
import { EditCurrentCustomer } from "./pages/customer/current/edit";
import { ViewCurrentCustomer } from "./pages/customer/current/view";
import { ViewFutureCustomer } from "./pages/customer/future/view";
import AddStakeholder from "./pages/customer/stakeholder/add";
import EditStakeholder from "./pages/customer/stakeholder/edit";
import ViewStakeholder from "./pages/customer/stakeholder/view";
import { AddTouchPoint } from "./pages/customer/touchpoint/add";
import { AddTouchPointPage } from "./pages/customer/touchpoint/touchPointPage";
import { ViewTouchPointPage } from "./pages/customer/touchpoint/touchPointPageView";
import { ViewTouchPoint } from "./pages/customer/touchpoint/view";
import ImportFile from "./pages/import-file";
import Verify from "./pages/verify/[id]";
import { routes } from "./routes";
import Authorized from "./routes/authorized";

import { TouchPointProvider } from "./lib/context/touchpointProvider";
import ImportError from "./pages/import-file/components/error";
import { ProgressPerformanceProvider } from "./lib/context/progressPerfomanceProvider";
import { KpiProvider } from "./lib/context/kpiProvider";
import ProgressPerfomance from "./pages/progress-perfomance";
import { AddIndicator } from "./pages/progress-perfomance/indicator/add";
import { AddPerformance } from "./pages/progress-perfomance/performance/add";
import { AddKPI } from "./pages/progress-perfomance/kpi/add";
import { AddProject } from "./pages/progress-perfomance/kpi/project/add";
import { EditIndicator } from "./pages/progress-perfomance/indicator/edit";
import { EditPerformance } from "./pages/progress-perfomance/performance/edit";
import { EditKPI } from "./pages/progress-perfomance/kpi/edit";
import { EditProject } from "./pages/progress-perfomance/kpi/project/edit";
import ExportFile from "./pages/export-file";
import ExportError from "./pages/export-file/components/error";
import KPI from "./pages/progress-perfomance/kpi";
import { AddCompetitor } from "./pages/customer/competitor/add";
import { EditCompetitor } from "./pages/customer/competitor/edit";
import { AddAreaUsage } from "./pages/customer/areaUsage/add";
import { EditAreaUsage } from "./pages/customer/areaUsage/edit";
import { AddVisit } from "./pages/customer/visit/add";
import { EditVisit } from "./pages/customer/visit/edit";

import VocReport from "./pages/voc-report";
import {VocReportProvider} from './lib/context/vocReportProvider';
import {ViewVocReport} from "./pages/voc-report/view"
import OrgChart from "./pages/org-chart";

export default function App() {
  //
  return (
    <Routes>
      <Route path="*" element={<p>There's nothing here: 404!</p>} />
      <Route path={routes.signin} element={<SignIn />} />
      <Route path={routes.forgot_password} element={<ForgotPassword />} />
      <Route path={routes.verify + "/:id"} element={<Verify />} />

      <Route element={<Authorized />}>
        <Route path={routes.ui} element={<UI />} />
        <Route path={routes.dashboard} element={<Dashboard />} />
        <Route
          path={routes.dashboard_marketingactionplan}
          element={<DashboardMarketingActionPlan />}
        />
        <Route
          path={routes.dashboard_customerpersona}
          element={<DashboardCustomerPersona />}
        />
        <Route
          path={routes.dashboard_customerpersonaestate}
          element={<DashboardCustomerPersonaEstate />}
        />
        <Route
          path={routes.dashboard_customersegment}
          element={<DashboardCustomerSegment />}
        />
        <Route 
          path={routes.dashboard_futurecustomerpersona} 
          element={<DashboardFutureCustomerPersona />} 
        />
        <Route
          path={routes.change_password + "/:id"}
          element={<ChangePassword />}
        />
        <Route path={routes.profile + "/:id"} element={<Profile />} />
        <Route
          path={routes.customer}
          element={
            <CustomerProvider>
              <Customer />
            </CustomerProvider>
          }
        />
        <Route
          path={routes.add_customer_current}
          element={
            <CustomerProvider>
              <AddCurrentCustomer />
            </CustomerProvider>
          }
        />
        <Route
          path={routes.view_customer_current + "/:id"}
          element={
            <CustomerProvider>
              <ViewCurrentCustomer />
            </CustomerProvider>
          }
        />

        <Route
          path={routes.edit_customer_current + "/:id"}
          element={
            <CustomerProvider>
              <EditCurrentCustomer />
            </CustomerProvider>
          }
        />

        <Route
          path={routes.add_customer_future}
          element={
            <CustomerProvider>
              <AddFutureCustomer />
            </CustomerProvider>
          }
        />
        <Route
          path={routes.select_channel_add_customer_future}
          element={
            <CustomerProvider>
              <SelectChannelAddFutureCustomer />
            </CustomerProvider>
          }
        />
        <Route
          path={routes.view_customer_future}
          element={
            <CustomerProvider>
              <ViewFutureCustomer />
            </CustomerProvider>
          }
        />
        <Route
          path={routes.add_customer_domestic_competitor}
          element={
              <AddCustomerCompetitorDomestic />
          }
        />
        <Route
          path={routes.add_customer_international_competitor}
          element={
              <AddCustomerCompetitorInternational />
          }
        />
        <Route
          path={routes.view_customer_domestic_competitor}
          element={
              <ViewCustomerCompetitorDomestic />
          }
        />
        <Route
          path={routes.view_customer_international_competitor}
          element={
              <ViewCustomerCompetitorInternational />
          }
        />
        <Route
          path={routes.add_customer_touchpoint}
          element={
            <CustomerProvider>
              <TouchPointProvider>
                <AddTouchPoint />
              </TouchPointProvider>
            </CustomerProvider>
          }
        />
        <Route
          path={routes.add_customer_touchpoint_page}
          element={
            <CustomerProvider>
              <TouchPointProvider>
                <AddTouchPointPage />
              </TouchPointProvider>
            </CustomerProvider>
          }
        />
        <Route
          path={routes.view_customer_touchpoint}
          element={
            <CustomerProvider>
              <TouchPointProvider>
                <ViewTouchPoint />
              </TouchPointProvider>
            </CustomerProvider>
          }
        />
        <Route
          path={routes.view_customer_touchpoint_page}
          element={
            <CustomerProvider>
              <TouchPointProvider>
                <ViewTouchPointPage />
              </TouchPointProvider>
            </CustomerProvider>
          }
        />

        <Route
          path={routes.add_customer_stakeholder}
          element={
            <CustomerProvider>
              <AddStakeholder />
            </CustomerProvider>
          }
        />

        <Route
          path={routes.edit_customer_stakeholder + "/:id"}
          element={
            <CustomerProvider>
              <EditStakeholder />
            </CustomerProvider>
          }
        />

        <Route
          path={routes.view_customer_stakeholder + "/:id"}
          element={
            <CustomerProvider>
              <ViewStakeholder />
            </CustomerProvider>
          }
        />

        {/* Competitor */}
        <Route
          path={routes.add_customer_competitor}
          element={
            <CustomerProvider>
              <AddCompetitor />
            </CustomerProvider>
          }
        />

        <Route
          path={routes.edit_customer_competitor + "/:id"}
          element={
            <CustomerProvider>
              <EditCompetitor />
            </CustomerProvider>
          }
        />

        {/* Area Usage */}
        <Route
          path={routes.add_customer_area_usage}
          element={
            <CustomerProvider>
              <AddAreaUsage />
            </CustomerProvider>
          }
        />

        <Route
          path={routes.edit_customer_area_usage + "/:id"}
          element={
            <CustomerProvider>
              <EditAreaUsage />
            </CustomerProvider>
          }
        />

        {/* Area Usage */}
        <Route
          path={routes.add_customer_visit}
          element={
            <CustomerProvider>
              <AddVisit />
            </CustomerProvider>
          }
        />

        <Route
          path={routes.edit_customer_visit + "/:id"}
          element={
            <CustomerProvider>
              <EditVisit />
            </CustomerProvider>
          }
        />

        {/* user_management */}
        <Route
          path={routes.user_management}
          element={
            <UserManagementProvider>
              <UserManagement />
            </UserManagementProvider>
          }
        />
        <Route
          path={routes.add_user_role_management}
          element={
            <UserManagementProvider>
              <AddUserRoleManagement />
            </UserManagementProvider>
          }
        />
        <Route
          path={routes.edit_user_role_management + "/:id"}
          element={
            <UserManagementProvider>
              <EditUserRoleManagement />
            </UserManagementProvider>
          }
        />
        <Route
          path={routes.view_user_role_management + "/:id"}
          element={
            <UserManagementProvider>
              <ViewUserRoleManagement />
            </UserManagementProvider>
          }
        />

        <Route
          path={routes.progress_performance}
          element={
            <ProgressPerformanceProvider>
              <ProgressPerfomance />
            </ProgressPerformanceProvider>
          }
        />
        <Route
          path={routes.add_indicator}
          element={
            <ProgressPerformanceProvider>
              <AddIndicator />
            </ProgressPerformanceProvider>
          }
        />
        <Route
          path={routes.add_report}
          element={
            <ProgressPerformanceProvider>
              <AddPerformance />
            </ProgressPerformanceProvider>
          }
        />
        <Route
          path={routes.add_kpi + "/:year"}
          element={
            <ProgressPerformanceProvider>
              <AddKPI />
            </ProgressPerformanceProvider>
          }
        />
        <Route
          path={routes.add_project + "/:id"}
          element={
            <ProgressPerformanceProvider>
              <AddProject />
            </ProgressPerformanceProvider>
          }
        />
        <Route
          path={routes.edit_indicator + "/:id"}
          element={
            <ProgressPerformanceProvider>
              <EditIndicator />
            </ProgressPerformanceProvider>
          }
        />
        <Route
          path={routes.edit_report + "/:id"}
          element={
            <ProgressPerformanceProvider>
              <EditPerformance />
            </ProgressPerformanceProvider>
          }
        />
        <Route
          path={routes.edit_kpi + "/:year" + "/:id"}
          element={
            <ProgressPerformanceProvider>
              <EditKPI />
            </ProgressPerformanceProvider>
          }
        />
        <Route
          path={routes.edit_project + "/:year" + "/:id"}
          element={
            <ProgressPerformanceProvider>
              <EditProject />
            </ProgressPerformanceProvider>
          }
        />
        <Route
          path={routes.kpi}
          element={
            <KpiProvider>
              <KPI />
            </KpiProvider>
          }
        />

        <Route
          path={routes.voc_report}
          element={
            <VocReportProvider>
              <VocReport />
            </VocReportProvider>
          }
        />
        {/* <Route
          path={routes.org_chart }
          element={<OrgChart />}
        /> */}

        <Route path={routes.import_file} element={<ImportFile />} />
        <Route path={routes.import_error + "/:id"} element={<ImportError />} />

        <Route path={routes.export_file} element={<ExportFile />} />
        <Route path={routes.export_file + "/:id"} element={<ExportError />} />
      </Route>
    </Routes>
  );
}
